import React, { useState } from "react";
import { useMutation } from "@apollo/react-hooks";
import { gql } from "apollo-boost";
import { number, string } from "prop-types";

import { STATUSES } from "../../constants/statuses";
import { respondToListingProgressChanged } from "../../events/listingProgressChanged";
import { dispatchTourRatingAdded } from "../../events/tourRatingAdded";
import RatingIcons from "./RatingIcons";
import * as S from "./styled";

export const RATE_LISTING_TOUR = gql`
  mutation rate_listing_tour($input: RateListingTourInput!) {
    rate_listing_tour(input: $input) {
      id
      rating
    }
  }
`;

const pushRatingToDataLayer = (rating, id) => {
  if (window.dataLayer === undefined) return;

  const data = window.dataLayer.find(d => d.pageCat !== undefined) || {};
  const { pageCat = "unknown", pageType = "unknown" } = data;

  window.dataLayer.push({
    event: "custom_event",
    event_category: `${pageCat}_${pageType}`,
    event_action: "submit_rating",
    event_label: `id=${id}|rating=${rating}`
  });
};

const useUpdateRating = (
  { listingId, listingJourneyId, listingType },
  setRating
) => {
  const [rateListingTour] = useMutation(RATE_LISTING_TOUR);

  return rating => {
    setRating(rating);
    dispatchTourRatingAdded({ listingId, listingType });
    pushRatingToDataLayer(rating, listingJourneyId);

    rateListingTour({
      variables: {
        input: {
          listing_class: listingType.toLowerCase(),
          listing_id: listingId,
          rating
        }
      }
    });
  };
};

const isStatusVisible = status =>
  STATUSES[status].index >= STATUSES.messaged.index;

const handleListingProgressChanged = (
  { listingId, listingType },
  setVisible
) => {
  respondToListingProgressChanged({ listingId, listingType }, e => {
    setVisible(isStatusVisible(e.detail.status));
  });
};

const TourRating = props => {
  const [rating, setRating] = useState(props.rating);
  const [isVisible, setVisible] = useState(isStatusVisible(props.status));

  const { listingId, listingType } = props;

  const updateRating = useUpdateRating(props, setRating);

  handleListingProgressChanged(props, setVisible);

  return isVisible ? (
    <S.TourRatingWrapper>
      <fieldset>
        <legend>
          Already toured? Add a personal review you can revisit anytime!
        </legend>
        <S.RatingIconWrapper>
          <RatingIcons
            listingId={listingId}
            listingType={listingType}
            rating={rating}
            updateRating={updateRating}
          />
        </S.RatingIconWrapper>
      </fieldset>
    </S.TourRatingWrapper>
  ) : null;
};

TourRating.propTypes = {
  listingId: number.isRequired,
  listingType: string.isRequired,
  // eslint-disable-next-line react/no-unused-prop-types
  listingJourneyId: number,
  rating: number,
  status: string.isRequired
};

TourRating.defaultProps = { rating: null, listingJourneyId: null };

export default TourRating;
